<div class="invitation-access-container">
  <div class="invitation-access-title">
    {{ 'BY-INVITATION-ACCESS.TITLE' | translate }}
  </div>
  <div 
    class="no-settings-needed-text" 
    [innerHTML]="(isCourse
        ? 'BY-INVITATION-ACCESS.ELEARNING.NO-SETTINGS-NEEDED'
        : 'BY-INVITATION-ACCESS.TRAINING.NO-SETTINGS-NEEDED'
      ) | translate
    "
  ></div>
  <div class="invitation-only-container">
    <span>✦</span>
    <span 
      [innerHTML]="'BY-INVITATION-ACCESS.INVITATION-ONLY' | translate"
    ></span>
  </div>
</div>